import styled from "styled-components";

export const SkeletonRoot = styled.div`
    min-height: 100vh;
    @media (max-width: 991px) {
        padding-bottom: 32px;
    }
`;

export const SkeletonHero = styled.section`
    position: relative;
    min-height: 600px;
    overflow: hidden;
    padding: 148px clamp(24px, 4vw, 72px) 72px;

    @media (max-width: 991px) {
        min-height: 520px;
        padding: 112px 18px 44px;
    }
`;

export const SkeletonHeroBackground = styled.div`
    position: absolute;
    inset: 24px clamp(24px, 4vw, 72px) 0;
    opacity: 0.95;

    @media (max-width: 991px) {
        inset: 16px 18px 0;
    }
`;

export const SkeletonHeroContent = styled.div`
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 18px;
    max-width: min(860px, 80vw);

    @media (max-width: 991px) {
        max-width: 100%;
        gap: 16px;
    }
`;

export const SkeletonSections = styled.div`
    display: flex;
    flex-direction: column;
    gap: 56px;
    padding: 0 clamp(24px, 4vw, 72px);

    @media (max-width: 991px) {
        gap: 40px;
        padding: 0 18px;
    }
`;

export const SkeletonSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const SkeletonCards = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 18px;
`;

export const SkeletonCard = styled.div`
    position: relative;
    width: min(414px, 100%);
    min-width: min(414px, 100%);
    max-width: min(414px, 100%);
    height: 258.75px;
    overflow: hidden;

    @media (max-width: 991px) {
        height: auto;
        aspect-ratio: 414 / 258.75;
    }
`;

export const SkeletonCardContent = styled.div`
    position: absolute;
    inset: auto 16px 16px 16px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
